import nengi from 'nengi'

export default class UnhideEntityMessage {
	static protocol = {
		entityId: { type: nengi.Number },
	}

	entityId: number

	constructor(entityId: number) {
		this.entityId = entityId
	}
}
